import type { PartnerBankAccountResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import { Grid2, Typography } from "@mui/material";
import type { FC } from "react";

const bankAccountResource = Resources.base.partner.detail.bankAccount;

type Props = {
	bankAccount: PartnerBankAccountResponseDto;
	index: number;
};

export const PartnerBankAccountInfoWidget: FC<Props> = ({
	bankAccount,
	index,
}) => {
	const { t } = useResource();
	return (
		<BaseCard title={`${t(bankAccountResource.title)} #${index + 1}`}>
			<Grid2 container>
				<Grid2 size={{ xs: 6 }} mt={0.5}>
					<Typography variant="body1" color="secondary" fontWeight={600}>
						{t(bankAccountResource.accountHolder)}
					</Typography>
					<Typography variant="subtitle1" mb={0.5}>
						{bankAccount.accountHolder}
					</Typography>
				</Grid2>

				<Grid2 size={{ xs: 6 }} mt={0.5}>
					<Typography variant="body1" color="secondary" fontWeight={600}>
						{t(bankAccountResource.bic)}
					</Typography>
					<Typography variant="subtitle1" mb={0.5}>
						{bankAccount.bic}
					</Typography>
				</Grid2>

				<Grid2 size={{ xs: 6 }} mt={0.5}>
					<Typography variant="body1" color="secondary" fontWeight={600}>
						{t(bankAccountResource.iban)}
					</Typography>
					<Typography variant="subtitle1" mb={0.5}>
						{bankAccount.iban}
					</Typography>
				</Grid2>
			</Grid2>
		</BaseCard>
	);
};
